import { DropdownModel } from './../../report/models/report-filter.model';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { ChangePasswordPopupComponent } from './changepassword-popup.component';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserProfileAddressModel, EmailAddressModel, UserProfileModel } from '../models/userprofile.model';
import { UserProfileService } from '../models/userprofile.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IKeyValueInterface, WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { Location } from '@angular/common';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';


@Component({
  selector: 'wego-userprofile',
  template: require('../views/userprofile.component.html'),
  styles: [
    `
    .input-group.telephone-group .input-group-addon {
      padding: 0px;
      border: 0px;
    }
    .country-select {
      width: 60px;
      border: 1px solid #d2d6de;
      padding: 3px;
    }
    `
  ],
  providers: [UserProfileService],
})


export class UserProfile implements OnInit, OnDestroy {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  sub: any;
  apiResponse: IAPIResponse;
  submitted = false;
  model: UserProfileModel;
  submitModel: UserProfileModel;
  errorModel: IKeyValueInterface[];
  message: string;
  errorMessage: string;
  urlDefaultPage: string;
  private popupMsg: string;
  private module: string;
  flatPickrConfigDateOfBirth: FlatPickrModel;
  isDateOfBirth: boolean = false;
  countryList: DropdownModel[];
  personCountryList: DropdownModel[];
  
  @ViewChild('changePasswordModal') public changePasswordModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('childModal') public childModal: any;
  

  constructor(private personService: UserProfileService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblProfile');
    this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
    this.translate.setDetectedLang();
    this.model = new UserProfileModel();
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.GetTelephoneCountry();
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.personService.GetUserByPersonHashId()
          .subscribe(
          res => {
            this.model = res.data;
            this.isDateOfBirth = this.model.dateOfBirth != '' ? true : false;
            if (this.model.liceanceNumberValidated) {
              this.flatPickrConfigDateOfBirth.clickOpens = false;
            }
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
            this.message = <any>error
          });
      });

      this.GetPersonCountry();
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = false;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.maxDate = new Date(new Date());
    return flatPickrConfig;
  }
  onSubmit(forms: any) {
    this.submitted = true;
    this.UpdatePersonProfile();
  }


  
  public GetPersonCountry() {
    this.authService.GetPersonCountry()
      .subscribe(
        res => {
          this.personCountryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public UpdatePersonProfile() {
    this.personService.UpdateUserProfile(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblRecordUpdatedSuccess', [this.module]);
          this.ShowSuccessPopup();

        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry()
        .subscribe(
          res => {
            this.countryList = res.data;
          },
          error => {
            this.authService.HandleErrorStatusCode(error);
          }
        );
  }

  public ShowChangePasswordModal(personMasterHashId: string) {
    this.changePasswordModal.personHashId = personMasterHashId;
    this.changePasswordModal.show();
  }

  public ChangePasswordModal($event: any) {
    this.message = $event.SuccessMessage;
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }


  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/userprofile/components/userprofile.componets.ts